import i18n from "i18next"
import { initReactI18next } from "react-i18next"

// Translations
import common_es from "./locales/es/common";
import common_en from "./locales/en/common";
import header_es from "./locales/es/header";
import header_en from "./locales/en/header";
import auth_es from "./locales/es/auth";
import auth_en from "./locales/en/auth";
import invoices_es from "./locales/es/invoices";
import invoices_en from "./locales/en/invoices";
import delivery_notes_es from "./locales/es/delivery-notes";
import delivery_notes_en from "./locales/en/delivery-notes";
import clients_es from "./locales/es/clients";
import clients_en from "./locales/en/clients";
import render_content_es from "./locales/es/render-content";
import render_content_en from "./locales/en/render-content";
import users_es from "./locales/es/users";
import users_en from "./locales/en/users";
import welcome_es from "./locales/es/welcome";
import welcome_en from "./locales/en/welcome";
import home_es from "./locales/es/home";
import home_en from "./locales/en/home";
import technicals_sheets_es from "./locales/es/technicals-sheets";
import technicals_sheets_en from "./locales/en/technicals-sheets";
import stocks_es from "./locales/es/stocks";
import stocks_en from "./locales/en/stocks";
import services_es from "./locales/es/services";
import services_en from "./locales/en/services";
import admin_home_es from "./locales/es/admin-home";
import admin_home_en from "./locales/en/admin-home";
import audit_es from "./locales/es/audit";
import audit_en from "./locales/en/audit";
import profile_es from "./locales/es/profile";
import profile_en from "./locales/en/profile";
import executions_es from "./locales/es/executions";
import executions_en from "./locales/en/executions";
import documentation_en from "./locales/en/documentation";
import documentation_es from "./locales/es/documentation";
import adminDocumentation_en from "./locales/en/admin-documentation";
import adminDocumentation_es from "./locales/es/admin-documentation";
import transportation_en from "./locales/en/transportation";
import transportation_es from "./locales/es/transportation";

// Moment
import initializeMoment from "./moment";

// Set languages and name spaces arrays
export const languages = [ 'en', 'es' /*Add more languages here */];
const nameSpaces = [ 'common', 'header', 'auth', 'invoices', 'deliveryNotes', 'clients', 'renderContent', 'users', 'welcome', 'home', 'technicalsSheets', 'stocks', 'services', 'adminHome', 'audit', 'profile', 'executions', 'transportation' /*Add more namespaces here*/ ];
const userLanguage = JSON.parse(localStorage.getItem("ac-extranet.user"))?.lang || "es";
export const defaultLocale = userLanguage;
export const defaultNS = 'common';

initializeMoment(defaultLocale);

i18n
    .use(initReactI18next)
    .init({
        resources: {
            es: {
                common: common_es,
                header: header_es,
                auth: auth_es,
                invoices: invoices_es,
                deliveryNotes: delivery_notes_es,
                clients: clients_es,
                renderContent: render_content_es,
                welcome: welcome_es,
                home: home_es,
                users: users_es,
                technicalsSheets: technicals_sheets_es,
                stocks: stocks_es,
                services: services_es,
                profile: profile_es,
                adminHome: admin_home_es,
                audit: audit_es,
                executions: executions_es,
                documentation: documentation_es,
                adminDocumentation: adminDocumentation_es,
                transportation: transportation_es
                /* Add more namespaces here */
            },
            en: {
                common: common_en,
                header: header_en,
                auth: auth_en,
                invoices: invoices_en,
                deliveryNotes: delivery_notes_en,
                clients: clients_en,
                renderContent: render_content_en,
                welcome: welcome_en,
                home: home_en,
                users: users_en,
                technicalsSheets: technicals_sheets_en,
                stocks: stocks_en,
                services: services_en,
                profile: profile_en,
                adminHome: admin_home_en,
                audit: audit_en,
                executions: executions_en,
                documentation: documentation_en,
                adminDocumentation: adminDocumentation_en,
                transportation: transportation_en
                /* Add more namespaces here */
            },
            /* Add more languages here */
        },

        fallbackNS: defaultNS,

        fallbackLng: defaultLocale,

        lng: defaultLocale,

        whitelist: languages,

        preload: languages,

        debug: process.env.NODE_ENV !== 'production',

        ns: nameSpaces,

        defaultNS: defaultNS,

        interpolation: {
            escapeValue: false // not needed for react!!
        },

        initImmediate: false,

    }).then(() => {});

export default i18n;